import type { GuildVisibility } from "./types";

/**
 * Human labels for the three join modes. Shared by the list badge, the detail
 * badge and the Settings segmented control so the wording cannot drift between
 * the three places that render it.
 */
const LABELS: Record<GuildVisibility, string> = {
  open: "Open",
  invite_only: "Invite only",
  closed: "Closed",
};

/** The label for a visibility value; unknown values render as-is. */
export function visibilityLabel(v: string): string {
  return LABELS[v as GuildVisibility] ?? v;
}

/**
 * The badge modifier a visibility maps to. The three values are visually
 * distinct: open is the affirmative green, closed is the "needs approval"
 * amber, and invite_only stays the neutral grey it has always been — which is
 * also the fallback for a value this build does not know about.
 */
export function visibilityTone(v: string): "open" | "invite" | "closed" {
  if (v === "open") return "open";
  if (v === "closed") return "closed";
  return "invite";
}
